const VoyageList = () => import('Views/voyageUserSubmit/voyage-list');
const VoyageMetaData = () => import('Views/voyageUserSubmit/voyage-metaData');
const voyageAdultList = () => import('Views/voyageUserSubmit/voyageAdult-list');

export default[
  { path: '/voyage-list', component: VoyageList },
  { path: '/voyage-metaData', component: VoyageMetaData },
  { path: '/voyage-metaData/:id', component: VoyageMetaData },
  { path: '/voyageAdult-list', component: voyageAdultList },
];



// WEBPACK FOOTER //
// ./src/router/voyageApply.js